import PropTypes from 'prop-types';
// @mui
import Button from '@mui/material/Button';
// routes
import { RouterLink } from 'src/routes/components';
// config
import { PATH_AFTER_LOGIN ,PATH_AFTER_SUPER_ADMIN_LOGIN} from 'src/config-global';
import { useMockedUser } from 'src/hooks/use-mocked-user';
import { Box } from '@mui/material';
import { createPathAfterLogin } from 'src/utils/services';

// ----------------------------------------------------------------------

export default function LoginButton({ sx }) {
  const { user } = useMockedUser();
  const pathAfterLogin = createPathAfterLogin(user);
  return (
    <>
      {user ? (
        <Button component={RouterLink} href={user?.user_type==="admin"? PATH_AFTER_SUPER_ADMIN_LOGIN : pathAfterLogin} variant="contained" color="primary" sx={{ mr: 1, ...sx }}>
          Dashboard
        </Button>
      ) : (
        <Button component={RouterLink} href={PATH_AFTER_LOGIN} variant="outlined" sx={{ mr: 1, ...sx }}>
          Login
        </Button>
      )}
    </>
  );
}

LoginButton.propTypes = {
  sx: PropTypes.object,
};



export function LoginButtonSmall({sx}){
  const { user } = useMockedUser();
  const pathAfterLogin = createPathAfterLogin(user);

  return (
    <Box sx={{ width: '100%', textAlign: 'center', mt: 2, px: 2 }}>
      {user ? (
        <Button component={RouterLink} href={user?.user_type==="admin" ? PATH_AFTER_SUPER_ADMIN_LOGIN : pathAfterLogin} variant="contained" color="primary" sx={{width:1, mr: 1, ...sx }}>
          Dashboard
        </Button>
      ) : (
        <Button component={RouterLink} href={PATH_AFTER_LOGIN} variant="outlined" sx={{ width: 1, mr: 1, ...sx }}>
          Login
        </Button>
      )}
    </Box>
  );
}
